import axios from '@/api/config.js'
import { getOSSAuth } from '@/api/authAPI'
import OSS from 'ali-oss'

const state = {
  credential: null
}

const getters = {

}

const mutations = {
  setCredential (state, payload) {
    state.credential = payload.credential
  }
}

const actions = {
  getAuth ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(getOSSAuth)
        .then((response) => {
          resolve(response.data.Credentials)
        })
    })
  },
  getSignedUrl ({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('getAuth')
        .then((credential) => {
          let client = new OSS({
            region: process.env.VUE_APP_OSS_REGION,
            accessKeyId: credential.AccessKeyId,
            accessKeySecret: credential.AccessKeySecret,
            stsToken: credential.SecurityToken,
            bucket: process.env.VUE_APP_OSS_BUCKET
          })
          resolve(client.signatureUrl(payload.path))
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
